var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93804 8.00418L15.7966 1.14562C16.0613 0.889968 16.0686 0.468148 15.813 0.203437C15.5573 -0.061274 15.1355 -0.0686141 14.8708 0.187039C14.8652 0.192388 14.8598 0.197854 14.8544 0.203437L7.99582 7.062L1.13729 0.203398C0.872577 -0.0522551 0.450759 -0.044915 0.195107 0.219796C-0.0542987 0.478026 -0.0542987 0.887392 0.195107 1.14562L7.05364 8.00418L0.195107 14.8627C-0.0650355 15.1229 -0.0650355 15.5447 0.195107 15.8049C0.455288 16.065 0.877106 16.065 1.13729 15.8049L7.99582 8.94636L14.8543 15.8049C15.1191 16.0606 15.5409 16.0532 15.7965 15.7885C16.0459 15.5303 16.0459 15.1209 15.7965 14.8627L8.93804 8.00418Z",
    fill: "#1C3753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/close_modal_icon.ae726c3718c3b6709bf9d73d6f743d84.svg";
export { ForwardRef as ReactComponent };